import { FC, ReactNode } from "react";
import { Link } from "react-router-dom";
import Container from "@/components/Container";
import CollapsibleList from "@/components/Collapsible/CollapsibleList";
import ROUTES from "@/data/Routes";

interface FAQSectionProps {
  data: {
    id: number;
    label: string;
    description: string | ReactNode;
  }[];
  variant?: "light" | "white";
}

const FAQSection: FC<FAQSectionProps> = ({ data, variant = "light" }) => {
  return (
    <section
      className={`flex flex-col px-4 py-12.5 md:px-6 md:py-25 ${variant === "white" ? "bg-white" : "bg-[#F5F5F5]"}`}
    >
      <Container>
        <div className="mx-auto flex w-full max-w-[740px] flex-col items-center justify-center gap-5">
          <h2 className="text-dark text-center text-[26px] leading-[120%] font-light md:text-[34px]">
            Dažniausiai užduodami klausimai
          </h2>
          <div className="mb-5 flex flex-col items-center gap-2 md:flex-row">
            <p className="text-body text-center text-base leading-[150%] font-light">
              Neradote čia ieškomo atsakymo?{" "}
            </p>
            <Link
              to={ROUTES.FAQ}
              className="text-base leading-[130%] font-light text-[#2A1645] underline decoration-solid underline-offset-[6.4px]"
            >
              Apsilankykite mūsų DUK
            </Link>
          </div>

          <div className="w-full">
            <CollapsibleList data={data} itemClassName="text-base font-light" />
          </div>
        </div>
      </Container>
    </section>
  );
};

export default FAQSection;
